import React from 'react';
import { CustomerMenuItemUI } from '@next-order/next-order-components';
import { handlePromotionRedemption } from './actions';

const PromotionItem = ({
  promotion,
  themeColors,
  pointsTerminology = 'points',
}) => {
  const { type, value, name, description, imageUrl } = promotion;

  // Capitalize points terminology
  const capitalizedTerminology =
    pointsTerminology.charAt(0).toUpperCase() + pointsTerminology.slice(1);

  // Determine chip text based on type
  const getChipText = () => {
    if (type === 1) {
      return `${value}x Earn`;
    } else if (type === 0) {
      return `${value} ${capitalizedTerminology}`;
    }
    return '';
  };

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Add logic for handling promotion click if needed
  };

  return (
    <CustomerMenuItemUI
      title={name}
      desc={description}
      currency=''
      price={getChipText()} // Using the chip text as the "price" to display
      displayType='grid'
      imgSrc={imageUrl || 'default-promotion-image.jpg'}
      onClick={handleClick}
      style={{
        wordBreak: 'break-word',
      }}
    />
  );
};

export default PromotionItem;
